module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "TocSb1"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/dedication",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part001#pt001"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")]), _vm._v(": C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("Chapter 1. The Apostle of Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s001"
    }
  }, [_vm._v("The Gods and the Cosmos in Ancient Thought and Worship")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s002"
    }
  }, [_vm._v("A Different God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s003"
    }
  }, [_vm._v("A Different Cosmos")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s004"
    }
  }, [_vm._v("Creation, Reason, and Argument")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s005"
    }
  }, [_vm._v("The Creator God as the Foundation of Pauline Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s006"
    }
  }, [_vm._v("Conclusion: Apostle of a Different God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002"
    }
  }, [_vm._v("Chapter 2. The Good News of the Fall")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2s1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s001"
    }
  }, [_vm._v("The Origin of Evil, Suffering, and Death")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2s2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s002"
    }
  }, [_vm._v("Pauline Anthropology: Human Beings as Originally Created")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch2s3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s003"
    }
  }, [_vm._v("The Body")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch2s4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s004"
    }
  }, [_vm._v("The Soul")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch2s5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s005"
    }
  }, [_vm._v("Body and Soul")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch2s6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s006"
    }
  }, [_vm._v("Sex and Gender")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch2s7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s007"
    }
  }, [_vm._v("The Image of God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2s8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s008"
    }
  }, [_vm._v("Pauline Anthropology: Human Beings as Fallen")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2s9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s009"
    }
  }, [_vm._v("Paul’s Doctrine of Original Sin in Its Ancient Context")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2s10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s010"
    }
  }, [_vm._v("Creation and Fall as the Map for Paul’s Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch2s11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s011"
    }
  }, [_vm._v("Conclusion: The Fallen Creation and the Good Creator")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part002#pt002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO")]), _vm._v(": I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCARNATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3. The Two Streams of Expectation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Exodus and Its Climax: The Name and Presence of God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Major Stream of Jewish Expectation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Second Major Stream of Jewish Expectation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Name and Presence of God in Paul’s Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch3s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Corinthians 8:4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch3s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colossians 1:16–17")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch3s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romans 10:12–13")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch3s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philippians 2:9–11")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch3s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Incarnational Christology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Two Streams of Expectation in Paul’s Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Secret of Paul’s Christology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4. Paul’s Gospel of the Incarnation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Incarnation in Its Ancient Pagan Context")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Incarnation and Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The One Lord of the Old Testament in Paul’s Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Divine but Not an Incarnational Christology?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God the Father and the Lord Jesus Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Anachronistic Reading of Paul?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Paul’s Incarnational Christology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5. The Epicenter of Paul’s Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch5s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Union with the Creator God in Pauline Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch5s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Participation as the Key to Pauline Christology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch5s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Participation within the Larger Narrative of Paul’s Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch5s4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Participation in Father, Son, and Holy Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch5s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Spirit of God’s Son")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch5s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Epicenter of Paul’s Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch5s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Heart of Paul’s Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part003#pt003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE")]), _vm._v(": C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVENANT")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6. Paul and the Law in Full Perspective")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch6s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Problem of the Law in Paul: The Challenge of the “New Perspective”")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch6s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Proposed Solutions to the Problem of the Law in Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch6s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “New Perspective” Solution")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch6s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “Two Covenants” Approach")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch6s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Modified Return to the “Old Perspective”")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch6s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Three Proposed Solutions: Why They Do Not (Fully) Work")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch6s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “New Perspective” Solution")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch6s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “Two Covenants” Approach")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch6s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Modified Return to the “Old Perspective”")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch6s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Solution to the Problem of Law and Covenant in Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch6s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Law and Covenant in Psalm 143")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch6s12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 143:2 in Covenantal Context")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch6s13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Righteousness Apart from the Covenant in Jewish Thought")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch6s14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romans 3:20 in Its Jewish and Covenantal Context")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch6s15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Law in Paul in Covenantal Perspective")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7. The Covenant and the Cross")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch7s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abrahamic Covenant and New Covenant in the Old Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch7s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Covenant of Abraham and the Cross of Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch7s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cross of Christ and the Love of God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch7s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Covenant and Communion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch7s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faith and the Covenant")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch7s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Covenant, Cross, and Communion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-008"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8. Justification within the Covenant")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Righteousness and Justification in Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch8s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Righteousness of God: Belonging to God or Given to Human Beings?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch8s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Righteousness of God: Forgiveness or Sanctification?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faith and Ethics in Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fulfillment of the Law")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Paul’s Covenantal Theology of Justification")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part004#pt004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(": K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INGDOM")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9. Easter in Ancient Context")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch9s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Everlasting Sorrow—Death and the Afterlife in Ancient Paganism")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch9s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ancient Philosophy")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch9s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Popular Thought and Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch9s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coping with Death in Antiquity")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch9s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Powerful Yearning")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch9s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Different Promise from a Different God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch9s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Good News of Jesus’s Resurrection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch9s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Interim State")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch9s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cosmic Judgment and Cosmic Renewal")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch9s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “Good News” of the Resurrection in Ancient Context")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch9s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The God Who Gives Life to the Dead")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch9s12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus’s Resurrection and the Mystery of God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch9s13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Good News of a Different God and His Victory")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10. The Resurrection of the Body in Paul’s Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch10s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Good News of the Resurrection: The Church’s Historic Reading of 1 Corinthians 15")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch10s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Less Than Good News: Contemporary Misreadings of 1 Corinthians 15")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch10s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Structure of Paul’s Argument in 1 Corinthians 15:36–54")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch10s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Analogy of the Seed in 1 Corinthians 15:36–41")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch10s5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “Spiritual Body” in 1 Corinthians 15:44")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch10s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Does 1 Corinthians 15:50 Preclude the Resurrection of the Flesh?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch10s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Central Verb for the Resurrection Event in 1 Corinthians 15")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch10s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Resurrection of the Body Elsewhere in Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch10s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Importance of the Resurrection of the Flesh in Paul’s Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch10s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Easter Gospel of 1 Corinthians 15")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11. The New Life")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch11s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creation’s Renewal Now Come in Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch11s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Sacramental New Life")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch11s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Transformation of the Intellect")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch11s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Creation-Renewing Power of Easter")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12. The New Law")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch12s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Law of Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch12s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Revolution of Love")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch12s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love for God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "ch12s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#s004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love of Neighbor")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch12s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#s005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marriage and Sexuality")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch12s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012#s006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The New Law of Christ in the Teaching of Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part005#pt005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVE")]), _vm._v(": P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUL AND")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGINS")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13. The Gospel of the Eyewitnesses")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch13s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Earliest Historical Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch13s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Most Valuable Source: 1 Corinthians 15:1–11")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch13s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Apostolic Origins of the Body of Teaching in 1 Corinthians 15:3–8")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch13s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#s004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Evidence from Paul’s Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch13s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013#s005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Evidence of Paul’s Letters for Christian Origins")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch-014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#ch014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14. Paul and Peter among the Apostles")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch14s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#s001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul within the Apostolic College")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch14s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#s002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Twelve as the Nucleus of the Apostolic College")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch14s3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#s003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Unique Place among the Apostles")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch14s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#s004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peter among the Apostolic Pillars")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch14s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#s005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul among the Apostolic Pillars")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch14s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#s006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peter and Paul in the Ancient Church")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch14s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#s007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Distinctive Role among the Apostolic Pillars")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch14s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#s008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Apostolic Pillars and the New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch14s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#s009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading Paul’s Letters within the New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch14s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014#s010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Paul among the Apostles and in the New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgements#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "idx-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#idx002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "idx-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index003#idx003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Scripture and Other Ancient Texts")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0